import DocumentationButton from "components/DocumentationButton";
import TierInfo from "components/TierInfo";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import useTypedContext from "hooks/useTypedContext";
import { BillingTierFeature } from "types/generated";
import { getDocsUrl } from "utils/getDocsUrl";
import { AccountContext } from "views/AccountWrapper";
import EmptyState from "ds/components/EmptyState";

import styles from "./styles.module.css";

const TemplatesUpSell = () => {
  const { viewer } = useTypedContext(AccountContext);

  return (
    <Box direction="column" align="center" fullWidth grow="1">
      <TierInfo
        type="callout"
        variant="promo"
        feature={BillingTierFeature.Blueprints}
        title="Upgrade plan to use Templates"
      >
        Templates are not available in your current plan. Upgrade to{" "}
        <strong>Business or Enterprise</strong> plan to use the feature.
      </TierInfo>

      <Box direction="column" align="center" padding="large" className={styles.upSellWrapper}>
        <EmptyState
          title="Enable Self-Service Infrastructure for Your Team"
          caption="Templates allow your team to deploy pre-configured stacks without manual setup. Define infrastructure patterns once, let anyone deploy them with confidence. Upgrade to Business or Enterprise to unlock this powerful self-service capability."
        >
          <Box align="center" gap="large">
            <DocumentationButton label="Documentation" to={getDocsUrl("/concepts/template")} />
            {viewer.admin && (
              <LinkButton to="/settings/billing" variant="contrast">
                Upgrade
              </LinkButton>
            )}
          </Box>
        </EmptyState>
      </Box>
    </Box>
  );
};

export default TemplatesUpSell;
